import { Alert } from "@mui/material";
import type { MessageTemplateSelectInputProps } from "@sinch/components/application/Messages/MessageTemplateSelectMenu";
import { MessageTemplateSelectMenu } from "@sinch/components/application/Messages/MessageTemplateSelectMenu";
import { MessageTemplates } from "@sinch/components/application/Messages/queries.graphql";
import type {
  MessageTemplatesQuery,
  MessageTemplatesQueryVariables,
} from "@sinch/components/application/Messages/queries.types";
import { NotificationChannel } from "@sinch/components/application/Messages/useMessageChannels";
import { useQueryHandler } from "@sinch/hooks/useQueryHandler";
import { isNilOrEmpty } from "ramda-adjunct";
import React from "react";
import { useTranslation } from "react-i18next";

export const AvailableTemplateBox = ({
  onApplyTemplate,
  channel,
  fillDefaultTemplate,
}: {
  onApplyTemplate: MessageTemplateSelectInputProps["onApplyTemplate"];
  channel: NotificationChannel;
  fillDefaultTemplate?: boolean;
}) => {
  const { t } = useTranslation();
  const { data } = useQueryHandler<MessageTemplatesQuery, MessageTemplatesQueryVariables>(MessageTemplates, {
    filter: { channel: { IN: [channel] }, category: { EQ: null } },
  });
  if (isNilOrEmpty(data?.messageTemplates)) {
    return null;
  }
  return (
    <Alert
      action={
        <MessageTemplateSelectMenu
          availableChannels={[channel]}
          fillDefaultTemplate={fillDefaultTemplate}
          onApplyTemplate={onApplyTemplate}
          size="small"
          variant="contained"
        />
      }
      severity="info"
      sx={{ borderColor: "secondary.main" }}
    >
      {t("Messages.youCanApplyTemplate")}
    </Alert>
  );
};
